import { render, staticRenderFns } from "./DescriptionPartial.vue?vue&type=template&id=6705f352&"
import script from "./DescriptionPartial.vue?vue&type=script&lang=js&"
export * from "./DescriptionPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports